export default {
    title: 'Prior Art',
    add: 'Add Prior Art',
    searchPlaceholder: 'Search patents...',
    noResults: 'No prior art found',
    searchHint: 'Add patents to track relevant prior art',
    viewDetails: 'View Patent Details',
    moreResults: 'More Prior Art',
    delete: 'Delete',
    cancel: 'Cancel',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    dialog: {
        title: 'Add Prior Art',
        subtitle: 'Search by patent number or describe the invention.',
        placeholder: 'e.g. US20230123456 or describe the invention: \'A fiber optic connector with a self-centering alignment mechanism using spring-loaded arms...\'',
        proTip: 'Pro tip: Paste a full paragraph for better semantic matching.',
        search: 'Search',
        searching: 'Searching...',
        found: 'Found',
        results: 'results',
        enterQuery: 'Enter a query to start searching',
        noResults: 'No matching patents found',
        resultsWillAppear: 'Search results will appear here',
        searchFailed: 'Search failed, please try again later',
        selected: 'selected',
        cancel: 'Cancel',
        addSelected: 'Add Selected',
        noSelected: 'Please select at least one patent',
        addSuccess: 'Successfully added {count} patent(s)',
        addFailed: 'Failed to add patents, please try again',
    },
};
